/**
 * TASK-912 — Direct quote customer availability chips (multi-select).
 * selectedSlot[requestId] is an array of { index, slot }. Legacy single object is normalized.
 */

export function normalizeSelectedSlots(value) {
  if (value == null || value === "") return [];
  if (Array.isArray(value)) {
    return value.filter((entry) => entry && (entry.slot != null || entry.index != null));
  }
  if (typeof value === "object" && (value.slot != null || value.index != null)) {
    return [value];
  }
  return [];
}

export function isDropoffAvailabilitySlot(slot) {
  if (!slot) return false;
  if (slot.is_dropoff === true) return true;
  if (slot.is_dropoff === false) return false;
  return !slot.start_time && !slot.end_time;
}

export function availabilitySlotDateOnly(slot) {
  const raw = slot?.date ?? slot?.available_date ?? "";
  return raw.toString().split("T")[0] || "";
}

export function isAvailabilityChipSelected(selectedForRequest, index) {
  return normalizeSelectedSlots(selectedForRequest).some((entry) => entry.index === index);
}

/** Toggle chip at index; returns next selected list for that request. */
export function toggleAvailabilityChip(selectedForRequest, index, slot) {
  const list = normalizeSelectedSlots(selectedForRequest);
  const exists = list.findIndex((entry) => entry.index === index);
  if (exists >= 0) {
    return list.filter((_, i) => i !== exists);
  }
  const dateOnly = availabilitySlotDateOnly(slot);
  return [
    ...list,
    {
      index,
      slot: {
        ...slot,
        date: dateOnly || slot?.date,
        is_dropoff: isDropoffAvailabilitySlot(slot),
      },
    },
  ];
}

/** HH:mm or HH:mm:ss + duration hours → end HH:mm */
export function endTimeFromStartAndDuration(startHHmm, durationHours) {
  const start = String(startHHmm || "").slice(0, 5);
  const parts = start.split(":");
  if (parts.length < 2) return null;
  const h = Number(parts[0]);
  const m = Number(parts[1]);
  const dur = Number(durationHours);
  if (!Number.isFinite(h) || !Number.isFinite(m) || !Number.isFinite(dur) || dur <= 0) {
    return null;
  }
  const totalMins = h * 60 + m + Math.round(dur * 60);
  const eh = Math.floor(totalMins / 60) % 24;
  const em = totalMins % 60;
  return `${String(eh).padStart(2, "0")}:${String(em).padStart(2, "0")}`;
}

export function partitionSelectedAvailability(selectedForRequest) {
  const list = normalizeSelectedSlots(selectedForRequest);
  const appointment = [];
  const dropoff = [];
  for (const entry of list) {
    if (isDropoffAvailabilitySlot(entry.slot)) dropoff.push(entry);
    else appointment.push(entry);
  }
  return { list, appointment, dropoff };
}
